.custom-screen-container {
  padding: 1.6rem 1.2rem 1.6rem 1.6rem;

  @media screen and (min-width: $bp-medium) {
    overflow: hidden;
    padding: 0 1.2rem 0 1.6rem;
  }
}

.drawer {
  position: absolute;
  top: 4rem;
  right: 0;
  bottom: 0;
  min-width: 26.5rem;
  width: 25%;
  z-index: 1000;
}
